export enum GameMode {
  PVP = 'pvp',
  PVE = 'pve',
  SOLOPVE = 'solo-pve',
}
